<template>
  <div v-if="dialogVisible" class="dialog-box">
    <div class="message-content-center">
      <div class="message-content-center-header-font" v-html="dialogInfo.content"></div>
      <div class="dialog-footer" v-if="dialogInfo.rightText && dialogInfo.leftText">
           <div class="left-button" v-if="dialogInfo.leftText && dialogInfo.leftText !==''" @click="restart">{{ dialogInfo.leftText }}</div>
           <div class="right-button" @click="coninute">{{ dialogInfo.rightText }}</div>
      </div>
    </div>
  </div>
<!--  <el-dialog-->
<!--    class="dialog"-->
<!--    :visible.sync="dialogVisible"-->
<!--    :close-on-click-modal="false"-->
<!--    :close-on-press-escape="false"-->
<!--    width="30%"-->
<!--    :show-close="false"-->
<!--  >-->
<!--    <p class="content">{{ dialogInfo.content }}</p>-->
<!--    <span slot="footer" class="dialog-footer">-->
<!--      <el-button class="left-button" type="primary" @click="restart">{{-->
<!--        dialogInfo.leftText-->
<!--      }}</el-button>-->
<!--      <el-button class="right-button" type="primary" @click="coninute">{{-->
<!--        dialogInfo.rightText-->
<!--      }}</el-button>-->
<!--    </span>-->
<!--  </el-dialog>-->
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {},
  methods: {
    restart() {
      this.$emit("restart");
    },
    coninute() {
      this.$emit("coninute");
    },
  },
};
</script>

<style lang='scss' scoped>
 .dialog-box {
   height: 100%;
   width: 100%;
   background: rgba(0,0,0,0.6);
   position: fixed;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   z-index: 10000;
   user-select: none;
 }
 .message-content-center {
   width: var(--width-489);
   height: var(--height-176);
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   padding: var(--padding-x-24);
   border-radius: var(--border-radius-6);
   border: var(--width-1) solid var(--color-gray-line-light);
   background: var(--color-white-base);
   box-shadow: 0 var(--margin-x-12) var(--margin-y-40) 0 rgba(0, 0, 0, 0.1);
   z-index: 50001;

   &-header-font {
     font-size: var(--font-size-h6);
     color: #1D2129;
     line-height: var(--font-line-height-m);
     font-weight: var(--font-weight-l);
   }
   .dialog-footer {
     display: flex;
     justify-content: flex-end;

     @mixin button-default {
       height: var(--height-40);
       border-radius: var(--width-20);
       font-size: var(--font-size-m);
       line-height: var(--font-line-height-m);
       padding: var(--padding-y-8) var(--padding-x-16);
       cursor: pointer;
       text-align: center;
       display: flex;
       flex-direction: row;
       align-items: center;
     }
     .left-button{
       @include button-default;
       margin-right: var(--margin-x-16);
       border: var(--width-2) solid var(--color-blue-active);
       color: var(--color-blue-active);
     }
     .right-button {
       @include button-default;
       background: var(--color-blue-active);
       color: var(--color-white-base);
     }
   }
   //&-header {
   //  display: flex;
   //  align-content: center;
   //  align-items: center;
   //}
   //&-content {
   //  font-size: var(--font-size-m);
   //  color: #1D2129;
   //  margin-top: var(--margin-y-16);
   //  line-height: var(--font-line-height-s);
   //}
 }
//.dialog {
//  display: flex;
//  flex-direction: column;
//  justify-content: center;
//  align-items: center;
//  border-radius: 100px;
//}
//.content {
//  font-weight: bold;
//  color: #2e2e2e;
//  font-size: 0.1375rem;
//  line-height: 0.25rem;
//  text-align: justify;
//}
//.left-button {
//  padding: 0 0.25rem !important;
//  margin: 0 0.1875rem 0 0;
//  // width: 0.925rem;
//  height: 0.2875rem;
//  border-radius: 0.14375rem;
//  // border: none;
//  background-color: #ffffff !important;
//  color: #5867fe;
//  &:hover {
//    color: #5867fe !important;
//    background-color: #eef0fe !important;
//  }
//}
//.right-button {
//  // width: 0.925rem;
//  padding: 0 0.25rem !important;
//  height: 0.2875rem;
//  border-radius: 0.14375rem;
//  border: none;
//  background-color: #5867fe !important;
//}
///deep/ .el-button {
//  padding: 0px;
//}
//// .button {
////   width: 150px;
////   margin-bottom: 20px;
////   border-radius: 24px;
//// }
///deep/ .el-dialog__header {
//  padding: 0;
//}
///deep/ .el-dialog__body {
//  display: flex;
//  flex-direction: row;
//  justify-content: center;
//  align-items: center;
//}
///deep/ .el-dialog__footer {
//  display: flex;
//  flex-direction: row;
//  justify-content: center;
//}
</style>



// WEBPACK FOOTER //
// src/components/common/abiltyBeginDialog.vue